import React, { createContext, useContext, useState, useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
  useEffect(() => {
    // Check for existing session
    const checkAuth = async () => {
      const token = localStorage.getItem('access_token');
      const userData = localStorage.getItem('user');
      
      if (token) {
        // Verify token with your backend
        const response = await axios.get(`${API_URL}/auth/verify`, {
          headers: { Authorization: `Bearer ${token}` }
      });
        
        if (response.data.valid) {
          // const userData = await response.json();
          setUser(JSON.parse(userData));
        } else {
          localStorage.removeItem('access_token');
        }
      }
    };

    checkAuth().catch((error) => console.error('Auth check failed:', error))
      .finally(() => setLoading(false));
  }, []);

  const login = async (userData) => {
    setUser(userData);
    localStorage.setItem('access_token', userData.token);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('access_token');
  };

  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};